(function($){

    // Menu animations
    $('#trigger').on('click', function(){

        if($(this).hasClass('open')){
            $('#mainMenu').removeClass('is-active');
            $(this).removeClass('open');
            $('body').removeClass('disable');
            $('#siteLogo').animate({}, 1000, function(){
                $(this).removeClass('reposition');
            });
            $('#header__contact-button').animate({}, 1000, function(){
                $(this).removeClass('reposition');
            });
            

        } else {

            $('body').addClass('disable');
            $(this).addClass('open');
            $('#mainMenu').addClass('is-active');
            $('#siteLogo').addClass('reposition');
            $('#siteLogo').animate({}, 750, function(){
                $(this).css('z-index', 90);
            });
            $('#header__contact-button').addClass('reposition');
            $('#header__contact-button').animate({}, 750, function(){
                $(this).css('z-index', 90);
            });

        }

    });

    $('#mainMenu a').on('click', function(){

    	if($('#trigger').hasClass('open')){

	        $('#trigger').removeClass('open');
	        $('body').removeClass('disable');
	        $('#siteLogo').animate({}, 1000, function(){
                $(this).removeClass('reposition');
	        });
	        $('#header__contact-button').animate({}, 1000, function(){
                $(this).removeClass('reposition');
	        });
	        $('#mainMenu').animate({top: '-100vh'}).fadeOut(1000);

	    }

    });

    // Scroll on click
    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top-130
        }, 1000);
    });


    $('.home-carousel').owlCarousel({
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        loop:true,
        margin:10,
        nav:false,
        //dots: true,
        dotsContainer: '#carousel-custom-dots',
        autoplay:true,
        autoplayTimeout:6000,
        autoplayHoverPause:true,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:1
            },
            1000:{
                items:1
            }
        }
    });

    $('.owl-dot').click(function () {
  owl.trigger('to.owl.carousel', [$(this).index(), 300]);
});

    // Remove empty paragraphs
    $('p:empty:not([role])').remove();

    // Seacrh Overlay
    $('#js-search-btn').on('click', function () {
        event.preventDefault();
        $('#js-c-search').addClass('isActive');
    });

    $('.c-search-close').on('click', function () {
        event.preventDefault();
        $('#js-c-search').removeClass('isActive');
    });


    $(window).scroll(function() {    
    var scroll = $(window).scrollTop();

     //>=, not <=
    if (scroll >= 100) {
        //clearHeader, not clearheader - caps H
        $(".c-site-header").addClass("fixed");
        } else {
            $(".c-site-header").removeClass("fixed");
        }
    }); 

     $('#js-accessibility').on('click', function() {
        event.preventDefault();
        $('.accessibility').toggleClass('active');
    });

     $('#accessibility-close').on('click', function() {
        event.preventDefault();
        $('.accessibility').removeClass('active');
    });


     $('#js-apply-job').on('click', function() {
        event.preventDefault();
        $('#apply-for-job').toggleClass('is-active');
    });

    

})(jQuery);